import React from 'react';
import { FadeIn, ChapterMark } from '../ui/BasicUI';
import { RamaAI } from '../silhouettes/AISilhouettes';
import { ScriptureSeal } from '../scriptures/Granthalaya';
import { YugaWheelSVG } from '../ui/YugaWheelSVG';

export function YugaTurn({ from, to, fromName, toName, line, dataYuga }) {
  return (
    <section className="yuga-turn" data-yuga={dataYuga} data-chapter={`Turn — ${fromName} → ${toName}`}>
      <FadeIn>
        <div className="big-wheel"><YugaWheelSVG stage={dataYuga} /></div>
      </FadeIn>
      <FadeIn delay={300}>
        <p className="turn-mark">{fromName} ends · {toName} begins</p>
      </FadeIn>
      <FadeIn delay={600}>
        <p className="turn-text">{line}</p>
      </FadeIn>
    </section>
  );
}

export function ChapterRama() {
  return (
    <section id="chapter-2" className="scene" data-yuga="treta" data-chapter="II — Rama" style={{ 
      paddingTop: 140,
      position: 'relative',
      minHeight: '100vh'
    }}>
      {/* Background AI Artwork integrated into the section */}
      <RamaAI />

      <div className="stage" style={{ position: 'relative', zIndex: 2 }}>
        <ChapterMark
          num="II"
          yuga="Treta Yuga · त्रेता युग · The Age of Three-Quarters"
          deva="राम"
          name="Rama — the one who keeps his word"
          meaning="When dharma needed an example, the example put on skin"
        />

        <div className="prose-grid" style={{ marginTop: '20vh' }}>
          <FadeIn className="prose-block">
            <span className="label">i · the prince who walked away</span>
            <h3>On the eve of his coronation, Rama left the city in the clothes of an exile.</h3>
            <p className="dropcap">
              He could have argued. He could have ruled. Instead he listened to his father's stumbled promise and walked into the forest for fourteen years — taking with him a wife, a brother, and a dharma so simple it could be carried in the hands.
            </p>
          </FadeIn>
          <FadeIn className="prose-block" delay={200}>
            <span className="label">ii · the forest, the abduction, the search</span>
            <h3>Then Sita was taken. And the universe rearranged itself around finding her.</h3>
            <p>
              Ravana, ten-headed, brilliant, ravenous, carried her south to Lanka over the sea. Rama wept like any man would. Then, like a god might, he raised an army of vanaras and walked to the edge of the ocean.
            </p>
          </FadeIn>
        </div>

        <div className="pull-quote">
          "Where there is Rama, there is Hanuman.<br/>Where there is devotion, there is no distance."
          <span className="attribution">Treta Yuga · oral tradition</span>
        </div>

        <FadeIn style={{ textAlign: "center", marginTop: 30 }}>
          <ScriptureSeal id="ramayana" label="The Ramayana · told first by Valmiki" hint="open the granth →" />
        </FadeIn>

        <FadeIn className="prose-block" style={{ margin: "0 auto", maxWidth: "44em", alignItems: "center" }}>
          <span className="label">iii · the kingdom that would not last</span>
          <h3 style={{ textAlign: "center" }}>Rama returned. The lamps came on. And for a while, the world was kind.</h3>
          <p style={{ textAlign: "center", margin: "0 auto" }}>
            Rama Rajya is what we call the memory of that kindness. It is also why we still light the lamps each year — not because they have stayed lit, but because we remember that they were.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
